import { render, staticRenderFns } from "./HyphenSensitive.vue?vue&type=template&id=045e864d&scoped=true"
import script from "./HyphenSensitive.vue?vue&type=script&setup=true&lang=js"
export * from "./HyphenSensitive.vue?vue&type=script&setup=true&lang=js"
import style0 from "./HyphenSensitive.vue?vue&type=style&index=0&id=045e864d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045e864d",
  null
  
)

export default component.exports